export default "__VITE_ASSET__B471DjOk__"